/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import AccountTitlesStore from '../../store/account_title/AccountTitlesStore'
import AccountTitleListView from '../../view/pages/account_title/AccountTitleListView'
import AccountTitleAction from '../../action/account_title'

class AccountTitleListContainer extends Component {
  static getStores() {
    return [AccountTitlesStore]
  }

  static calculateState(prevState, props) {
    return {
      titles: AccountTitlesStore.getState(),
      ...props
    }
  }

  componentDidMount() {
    AccountTitleAction.fetchAccountTitles()
  }

  render() {
    return AccountTitleListView(this.state)
  }
}

export default withRouter(Container.create(AccountTitleListContainer, { withProps: true }))
